import { DISABLED } from '../config/constants';

const addToCart = async (button, variant, relatedProduct, additionalProductId = null) => {
  // Check if this is a sold out button (has data-bis attribute)
  if (button.hasAttribute('data-bis')) {
    return; // Don't add to cart if it's a sold out button
  }

  button.setAttribute(DISABLED, DISABLED);
  const items = [
    {
      quantity: 1,
      id: variant.id,
    },
  ];
  if (relatedProduct) {
    const select = relatedProduct.querySelector('select');
    if (select && select.value && select.value !== 'none') {
      const parts = select.value.split('/');
      const relatedId = parseInt(parts[parts.length - 1], 10);

      items.push({ quantity: 1, id: relatedId, properties: { addOn: true } });
    }
  } else if (additionalProductId && additionalProductId !== 'none') {
    // Fallback for when we only have the ID but no element
    // Note: We can't validate price here since we don't have the element
    // This should only be used when we're certain the product has a price
    items.push({ quantity: 1, id: additionalProductId, properties: { addOn: true } });
  }

  const request = await fetch('/cart/add.js', {
    body: JSON.stringify({ items }),
    credentials: 'include',
    headers: {
      Accept: 'application/json, text/plain, */*',
      'Content-Type': 'application/json',
    },
    method: 'POST',
  });
  try {
    const response = await request.json();
    if (request.ok) {
      // window.location.assign('/cart');
      const event = new CustomEvent('add-to-cart', { detail: { items } });
      window.dispatchEvent(event);
    } else {
      alert(`We had a problem adding that to your cart. \n${response.description || response.message}`);
    }
  } catch (err) {
    console.error(err);
  }
  button.removeAttribute(DISABLED);
};
export default addToCart;
